export default __webpack_public_path__ + "static/media/White-Chocolate-Cake.4122cb9e.jpg";